import { mount } from 'blop'
import { createState } from './state.blop'
import { createRouter } from './routing.blop'
import { Index } from './index.blop'

proxiedState = createState()
router = createRouter(proxiedState, window)

// The render function for this application
render = () => {
  proxiedState.$.flush() // full re-render: we can flush all recorded state changes
  tree = <Index state=proxiedState />
  return tree
}

// Boot up the app on the client
{ refresh, init } = mount(document.getElementById('app'), render)
init()

pending = false

// Only do a full tree refresh when the route changes (which restructures the
// whole page). Todo mutations, dog-page state, etc. are handled automatically
// by the reactive subscription system — each Component re-renders itself when
// a path it read during its last render is written to.
proxiedState.$.listen((path) => {
  if !path.startsWith('route') {
    return
  }
  if pending {
    return
  }
  pending := true
  Promise.resolve().then(() => {
    console.log('Route changed, refreshing the whole tree')
    pending := false
    refresh((time) => {
      if time > 50 {
        console.warn(`Slow render: `time`ms`)
      }
    })
  })
})
